// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamListItemContentSection-module--container--26cd38","heading":"TeamListItemContentSection-module--heading--b3e0f5"};